// extracted by mini-css-extract-plugin
export default {"tooltip":"cDKcEg_2n","content":"cW9vehcjJ","text":"cUzl2LXw7","small":"cbj0u8QEh","arrow":"cix4MQ4dN","wider":"c_Y445Qfi","bottomPosition":"cRGc9jui8","onlyWithClick":"c2_lKYELB"};